var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{attrs:{"flat":"","color":"transparent"}},[_c('v-container',{staticClass:"pa-0 ma-0",attrs:{"fluid":""}},[_c('v-row',{attrs:{"no-gutters":"","justify":"center","align":"center"}},[_c('v-col',{class:_vm.classes,attrs:{"cols":"auto"}},[_vm._v(" "+_vm._s(_vm.value)+" ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }